/**
 * Created by danielr on 08-Jun-15.
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var template = require("manager-templates/data-sources/integrations/authentication/types/OAuth2ImplicitView.tmpl");
    var InputField = require("ui/input-field/InputField");
    var LEConfig = require("assets/config/le-env-conf");
    var DomUtilities = require("infra-util/DomUtilities");
    var OAuth2ImplicitView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        OAuth2ImplicitView = Marionette.ItemView.extend({
            template : template,
            withUIComponents : true,

            /*
            for all the input field give the id of the ui and ui component same than the name of the attribute model
            so that the setError function can be executed dynamically.
            ex: this.ui.jwtPublicKey, this.uiComponents.jwtPublicKey and for the model attribute: jwtPublicKey
             */
            ui : {
                authorizationEndpoint: ".authorizationEndpoint",
                jwtPublicKey: ".jwtPublicKey",
                jsMethodName: ".jsMethodName",
                jsContext: ".jsContext",
                code: ".code"
            },

            uiComponents : {
                authorizationEndpoint:{
                    type: InputField,
                    options:{
                        el:"view.ui.authorizationEndpoint",
                        maxLength:ManagerConfig.dataSources.mainConfig.authenticationServer.MAX_LENGTH_FIELDS,
                        permutation: InputField.Permutation.B,
                        value: "view.model.getAuthorizationEndpoint"
                    },
                    events:{
                        change:"_onAuthorizationEndpointChange"
                    }
                },
                jwtPublicKey:{
                    type: InputField,
                    options:{
                        el:"view.ui.jwtPublicKey",
                        maxLength:ManagerConfig.dataSources.mainConfig.authenticationServer.MAX_LENGTH_FIELDS,
                        permutation: InputField.Permutation.B,
                        value: "view.model.getJwtPublicKey"
                    },
                    events:{
                        change:"_onJwtPublicKeyChange"
                    }
                },
                jsMethodName:{
                    type: InputField,
                    options:{
                        el:"view.ui.jsMethodName",
                        maxLength:ManagerConfig.dataSources.mainConfig.authenticationServer.MAX_LENGTH_FIELDS,
                        permutation: InputField.Permutation.B,
                        value: "view.model.getJsMethodName"
                    },
                    events:{
                        change:"_onJsMethodNameChange"
                    }
                },
                jsContext:{
                    type: InputField,
                    options:{
                        el:"view.ui.jsContext",
                        maxLength:ManagerConfig.dataSources.mainConfig.authenticationServer.MAX_LENGTH_FIELDS,
                        permutation: InputField.Permutation.B,
                        value: "view.model.getJsContext"
                    },
                    events:{
                        change:"_onJsContextChange"
                    }
                }
            },
            events: {
                "click @ui.code": "_selectText"
            },

            customTemplateHelpers: function() {
                return {
                    code: LEConfig.LPPublicKey
                };
            },

            initialize : function (options) {
                LEManager.logger.debug("OAuth2ImplicitView:initialize");
            },
            onRender: function(){
                _.defer(_.bind(function(){
                    this._selectText();
                }, this));
            },

            setError:function(err){
                LEManager.logger.info("OAuth2ImplicitView:setError");
                var _this = this;
                _.each(err, function(value, key){
                    if (_.has(_this.uiComponents, key)){
                        _this.uiComponents[key].setError(true, value);
                    }
                });
            },

            onValidatedInvalid:function (model, errors) {
                LEManager.logger.info("OAuth2ImplicitView:onValidatedInvalid");
                this.setError(errors);
                LEManager.notifier.showError({content : LE.translator.translate("LEManager.manager.dataSources.authentication.server.input.invalid")});
            },

            onValidatedValid: function () {
                LEManager.logger.debug("OAuth2ImplicitView:onValidatedValid");
                this.uiComponents.authorizationEndpoint.setError(false, "");
                this.uiComponents.jwtPublicKey.setError(false, "");
                this.uiComponents.jsMethodName.setError(false, "");
                this.uiComponents.jsContext.setError(false, "");
            },

            _onAuthorizationEndpointChange: function(componentId, eventName, value){
                LEManager.logger.debug("OAuth2ImplicitView:_onAuthorizationEndpointChange");
                this.model.setAuthorizationEndpoint(value);
            },

            _onJwtPublicKeyChange: function(componentId, eventName, value){
                LEManager.logger.debug("OAuth2ImplicitView:_onJwtPublicKeyChange");
                this.model.setJwtPublicKey(value);
            },

            _onJsMethodNameChange: function(componentId, eventName, value){
                LEManager.logger.debug("OAuth2ImplicitView:_onJsMethodNameChange");
                this.model.setJsMethodName(value);
            },

            _onJsContextChange: function(componentId, eventName, value){
                LEManager.logger.debug("OAuth2ImplicitView:_onJsContextChange");
                this.model.setJsContext(value);
            },

            _selectText : function () {
                DomUtilities.selectItemText(this.ui.code);
            },

            onClose : function () {
                LEManager.logger.debug("OAuth2ImplicitView:onClose");
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return OAuth2ImplicitView;
});
